import { render } from "./ConfirmTyre.vue?vue&type=template&id=6fb74e68&scoped=true"
import script from "./ConfirmTyre.vue?vue&type=script&lang=js"
export * from "./ConfirmTyre.vue?vue&type=script&lang=js"

import "./ConfirmTyre.vue?vue&type=style&index=0&id=6fb74e68&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fb74e68"]])

export default __exports__